import { CollageConfig } from '../components/CollageSection';

/**
 * Configuration for collage images
 * 
 * To add a new collage:
 * 1. Add your base collage image to /react-app/src/assets/collages/
 * 2. Add individual clickable item images to /react-app/src/assets/collages/items/
 * 3. Import them above
 * 4. Add a new CollageConfig object to the array below
 * 
 * Positioning guide:
 * - x, y: Percentage from left/top (0-100)
 * - width: Percentage of container width (recommended: 5-20 for small items)
 * - The item will be centered on the x,y coordinates
 */

// Example imports (uncomment and update with your actual images):
import collage1Base from '../assets/collages/items/art.jpg';
// import collage1BaseLowRes from '../assets/collages/collage-1-base-lowres.jpg';
import boatDude from '../assets/boat_dude.png';
// import photoItem from '../assets/collages/items/photo.png';

export const collageData: CollageConfig[] = [
    // Example configuration (uncomment and customize):
    {
        id: 'collage-1',
        baseImage: collage1Base,
        // baseImageLowRes: collage1BaseLowRes, // Optional: smaller version for progressive loading
        alt: 'My first collage',
        caption: '', // Optional
        clickableItems: [
            {
                image: boatDude,
                x: 51,     
                y: 68,     
                width: 15,  // 20% of container width
                link: 'https://google.com',
                alt: 'Boat Dude'
            }
        ]
        // clickableItems: [
        //     {
        //         image: butterflyItem,
        //         x: 25,      // 25% from left
        //         y: 30,      // 30% from top
        //         width: 10,  // 10% of container width
        //         link: 'https://example.com/butterfly',
        //         alt: 'Butterfly'
        //     },
        //     {
        //         image: photoItem,
        //         x: 75,      // 75% from left
        //         y: 50,      // 50% from top
        //         width: 15,  // 15% of container width
        //         link: 'https://example.com/photo',
        //         alt: 'Photo'
        //     },
        //     // Add more clickable items here
        // ]
    },
    // Add more collages here
];
